import { FormControl, TextField } from '@mui/material';
import { ChangeEventHandler } from 'react';

export const DataBaseNameField: React.FC<{
  databaseName: string;
  onChange: ChangeEventHandler<HTMLInputElement>;
}> = ({ databaseName, onChange }) => {
  return (
    <FormControl className="provision-field">
      <TextField
        id="database-name"
        label="Database Name"
        value={databaseName}
        name={'databaseName'}
        onChange={onChange}
        fullWidth
        variant="outlined"
        placeholder="Enter database name"
        helperText="The name of the database to connect to"
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: '8px',
          },
        }}
      />
    </FormControl>
  );
};
